// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"807":"e3942a1d","847":"1ea199fb","974":"41fe98e3"}[chunkId] + ".css";
};